module.exports = __webpack_public_path__ + "img/Hummingbirds_1_MockedUp.344bd50c.jpg";